import { defineStore } from "pinia";
import { computed, ref } from "vue";

type Options = {
    message: string;
    type: string;
    timeout?: number;
    width?: number;
};

export const useSnackbarStore = defineStore("snackbar", () => {
    const opened = ref(false);
    const message = ref("");
    const type = ref("");
    const timeout = ref(4000);
    const width = ref(100);

    const location = computed(() => {
        if (type.value === "success" || type.value === "info") {
            return "top right";
        }

        return "top";
    });

    const icon = computed(() => {
        if (type.value === "success") {
            return "fal fa-check-circle fa-fw";
        }

        if (type.value === "info") {
            return "fal fa-info-circle fa-fw";
        }

        return "fal fa-exclamation-triangle fa-fw";
    });

    const color = computed(() => {
        if (type.value === "success") {
            return "green";
        }

        if (type.value === "info") {
            return "orange";
        }

        return "error";
    });

    function open(options: Options) {
        message.value = options.message;
        type.value = options.type;

        if (options.timeout) {
            timeout.value = options.timeout;
        }

        if (options.width) {
            width.value = options.width;
        }

        opened.value = true;
    }

    function close() {
        opened.value = false;
    }

    return {
        opened,
        message,
        type,
        timeout,
        width,
        location,
        icon,
        color,
        open,
        close,
    };
});
